import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-dashborad',
  imports: [],
  templateUrl: './admin-dashborad.component.html',
  styleUrl: './admin-dashborad.component.css'
})
export class AdminDashboradComponent {

}
